import AlertIcon from '@atlaskit/icon/core/alert';
import * as React from 'react';

export function SvgAlertBulb() {
  return <AlertIcon label="" testId="ads-refreshed-icon" />;
}
